
import { defineComponent } from "vue";
import router from "@/router";

import AcademicCompetencyBasicDataTab from "./AcademicCompetencyBasicDataTab.vue";
import CompetencyPeriodAssignmentsTab from "./CompetencyPeriodAssigmentContent.vue";
import AcademicPerformancesTab from "./PerformancesContent.vue";

import { IAcademicCompetenciesModel } from "@/interfaces/modules";
import AcademicCompetenciesService from "@/api/AcademicBase/AcademicCompetenciesService";

export default defineComponent({
    name: "AcademicCompetenciesDetailView",
    components: {
        AcademicCompetencyBasicDataTab,
        CompetencyPeriodAssignmentsTab,
        AcademicPerformancesTab,
    },
    data() {
        return {
            activeTab: 0,
            competencyId: 0,
            competency: {} as IAcademicCompetenciesModel,
            loading: false,
            loaded: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.competencyId > 0 ? false : true;
        },
    },
    async mounted() {
        const idParam = this.$route.params.Id as string | undefined;
        const id = idParam ? parseInt(idParam, 10) : 0;
        this.competencyId = isNaN(id) ? 0 : id;

        if (!this.isNew) {
            await this.loadCompetency();
        }
        this.loaded = true;

    },
    methods: {
        setTab(index: number) {
            this.activeTab = index;
        },
        async loadCompetency() {
            this.loading = true;
            try {
                const result =
                    await AcademicCompetenciesService.GetAcademicCompetenciesById({
                        Id: this.competencyId,
                    } as IAcademicCompetenciesModel);
                this.competency = result;
                this.loaded = true;
            } finally {
                this.loading = false;
            }
        },
        goBack() {
            router.back();
        },
        async onBasicDataSaved(updated: IAcademicCompetenciesModel) {
            this.competency = updated;
            this.competencyId = updated.Id;

            // Si era nuevo y se acaba de crear, habilitamos las otras pestañas
            if (this.isNew) {
                // forzar refresh del estado (en realidad computed ya lo recalcula)
            }
        },
    },
});
